import React, { Component } from "react";
import { connect } from "react-redux";

import {
  addToBucket,
  removeFromBucket,
  setPopup,
} from "../actions/siteActions";

class Bucket extends Component {
  removeFromBucket = (item) => {
    this.props.removeFromBucket(item);
  };
  componentDidUpdate() {
    //console.log("YES----------");
    this.checkBucketLength();
  }
  checkBucketLength = () => {
    const { site } = this.props;
    Object.keys(site.bucket).length < 1 && this.props.setPopup("", false);
  };
  render() {
    const { site } = this.props;
    let backgroundColor;
    return (
      <ul className="bucket">
        {Object.keys(site.bucket).map((item, i) => {
          Object.keys(site.categories).map((cat, j) => {
            if (
              site.categories[cat].id ===
              site.bucket[item].product_categories[0]
            ) {
              backgroundColor = site.categories[cat].acf.varvus;
            }
          });
          return (
            <li key={i} style={{ backgroundColor: backgroundColor }}>
              {site.bucket[item].acf.title_2 ? (
                <span
                  dangerouslySetInnerHTML={{
                    __html: site.bucket[item].acf.title_2,
                  }}
                ></span>
              ) : (
                site.bucket[item].title.rendered
              )}
              <div
                className="closeBtn"
                onClick={() => this.removeFromBucket(item)}
              >
                ✕
              </div>
            </li>
          );
        })}
      </ul>
    );
  }
}

const mapStateToProps = (state) => ({
  site: state.site,
});

export default connect(mapStateToProps, {
  addToBucket,
  removeFromBucket,
  setPopup,
})(Bucket);
